import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = hash.split('session_id=')[1]?.split('&')[0];

    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        // Clean the hash
        window.history.replaceState(null, '', window.location.pathname);
        navigate(`/${user.role}/dashboard`, { replace: true });
      } catch {
        navigate('/login');
      }
    })();
  }, [navigate, exchangeSession]);

  return (
    <div className="flex items-center justify-center h-screen bg-slate-50">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full mx-auto" />
        <p className="mt-4 text-slate-500">Connexion en cours...</p>
      </div>
    </div>
  );
}
